module.exports = __webpack_public_path__ + "static/media/img-physical-qr.31628ce3.svg";